import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';
import { Power1, Power0, Power4, TimelineMax, TweenLite } from "gsap/TweenMax";
import 'TextPlugin';
import 'CSSRulePlugin';
import 'CSSPlugin';
import 'animation.gsap';
import 'debug.addIndicators';
import TweenMax from 'gsap/TweenMaxBase';

export default () => {



    var controller = new ScrollMagic.Controller();


    var wipeAnimation = new TimelineMax();

    $('#pinContainer .bottle-item').each(function (i, elem) {
        if(i==0) {
            $(elem).addClass('current-bottle');
        }
        new ScrollMagic.Scene({
            triggerElement: elem,
            triggerHook: 'onLeave',
            duration: ($(window).height() / 2) + 'px',
        })
            .on("leave", function (event) {
                var datatarget = null;
                if(event.scrollDirection == "FORWARD") {
                    datatarget = $(elem).attr('data-target-next');
                }
                if(event.scrollDirection == "REVERSE") {
                    datatarget = $(elem).attr('data-target-prev');
                }
                if ($(datatarget).offset() !== undefined) {
                    //$(window).scrollTop($(datatarget).offset().top);
                }
            })
            .on("enter", function (event) {
                var datatarget = null;
                if(event.scrollDirection == "FORWARD") {
                    datatarget = $(elem).attr('data-target-next');
                }
                if(event.scrollDirection == "REVERSE") {
                    datatarget = $(elem).attr('data-target-prev');
                }
                setTimeout(function() {
                    //$('#pinContainer .bottle-item').removeClass('current-bottle');
                    $(datatarget).addClass('current-bottle');
                }, 1000);
            })
            .setPin(this)
            .setTween(wipeAnimation)
            //.addIndicators()
            .addTo(controller);
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/full_scroll_bottles.js